import { FlyoutDrsFileInfoGeneric } from "components/FlyoutDrsFileInfo/FlyoutDrsFileInfoGeneric";
import { RightFlyoutContent } from "../store/DataTableProvider.types";
import { FlyoutTableDescription } from "components/FlyoutTableDescription/FlyoutTableDescription";

interface DataTableFlyoutRightProps {
  content: RightFlyoutContent;
  fileId?: string;
  onClose: () => void;
  tableId: string;
}

/** Component that renders a right-side flyout for a data table */
export const DataTableFlyoutRight = ({
  content,
  fileId,
  onClose,
  tableId,
}: DataTableFlyoutRightProps) => {
  if (content === "fileInfo" && fileId !== undefined) {
    return (
      <FlyoutDrsFileInfoGeneric drsFile={{ id: fileId }} onClose={onClose} />
    );
  }
  if (content === "tableDescription") {
    return <FlyoutTableDescription tableId={tableId} onClose={onClose} />;
  }
  return null;
};
